import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[buttonToggleLabel]',
  standalone: true
})
export class ButtonToggleLabelDirective {
  constructor(public tpl: TemplateRef<any>) {}
}
